import PropTypes from "prop-types";
import { CardEventCounter } from "components/EventTeeTimes/components/cardEvent/cardEventCounter";
import { formatFirestoreTimeStamp } from "utils";
import "./styles.css";
import { Timestamp } from "firebase/firestore";

function TeeTimeInfo({
  courseName,
  teeTimeTimestamp,
  users,
  fiveSomes,
  matchPlay,
}) {
  const date = formatFirestoreTimeStamp(teeTimeTimestamp, "MMMM dd, yyyy");

  return (
    <div className="tee-time-info--wrapper">
      <div className="tee-time-info--course-name">{courseName}</div>
      <div className="tee-time-info--date">{date}</div>

      <div style={{ marginTop: 16 }}>
        <CardEventCounter
          users={users}
          fiveSomes={fiveSomes}
          matchPlay={matchPlay}
        />
      </div>
    </div>
  );
}

TeeTimeInfo.defaultProps = {
  courseName: "",
  teeTimeTimestamp: new Timestamp(),
  fiveSomes: false,
  matchPlay: false,
};

TeeTimeInfo.propTypes = {
  courseName: PropTypes.string,
  teeTimeTimestamp: PropTypes.instanceOf(Timestamp),
  users: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])).isRequired,
  fiveSomes: PropTypes.bool,
  matchPlay: PropTypes.bool,
};

export { TeeTimeInfo };
